import { styled } from '@material-ui/core';
import { Input as BaseInput } from '@tuunetech/tuune-components';

export const Input = styled(BaseInput)({
  marginRight: 16,
  width: 250,
});
